var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select",
    {
      ref: "select",
      staticClass: "form-control",
      attrs: { multiple: "multiple", disabled: _vm.options.length === 0 }
    },
    _vm._l(_vm.mappedOptions, function(option, i) {
      return _c(
        "option",
        { key: option.label + "-" + i, domProps: { value: option.value } },
        [_vm._v(_vm._s(option.label))]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }